function o() {
  let e;
  if (typeof self < "u" && (e = self), typeof window < "u" && (e = window), typeof global < "u" && (e = global), typeof globalThis < "u" && (e = globalThis), e)
    return e;
  throw new Error("unable to locate global object");
}
export {
  o as getGlobal
};
//# sourceMappingURL=getGlobal.mjs.map
